import { SVGProps } from 'react'

export const UKFlagIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    {...props}
  >
    <defs>
      <clipPath id='clip0_uk-flag'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
    <g clip-path='url(#clip0_uk-flag)'>
      <path
        d='M15.3751 24.375H24.3751C25.4871 24.375 26.4321 24.1241 27.2168 23.6871L15.3751 16.6232V24.375ZM29.8088 19.9931C29.9371 19.4211 30.0023 18.8153 30.0023 18.1869V15.3744H22.0655L29.8066 19.9931M-5.80305 3.98944C-5.93652 4.58787 -6.00256 5.19937 -5.99992 5.8125V8.625H1.96733L-5.80305 3.98944ZM8.62508 -0.375H-0.374924C-1.47911 -0.375 -2.41792 -0.1275 -3.19924 0.303375L8.62508 7.35713V-0.375ZM-3.16324 23.7146C-2.38924 24.1331 -1.4628 24.375 -0.374924 24.375H8.62508V16.6823L-3.16324 23.7146ZM-5.99992 15.375V18.1875C-5.99992 18.8349 -5.9313 19.4588 -5.79574 20.0454L2.0337 15.375H-5.99992ZM27.2523 0.330938C26.4614 -0.117937 25.5035 -0.375 24.3751 -0.375H15.3751V7.41619L27.2523 0.330938ZM30.0001 8.625V5.8125C30.0001 5.19712 29.9365 4.60369 29.8133 4.04231L22.1318 8.625H30.0001Z'
        fill='#2E3192'
      />
      <path
        d='M22.1318 8.625L29.8132 4.04231C29.4611 2.43131 28.6039 1.09763 27.2522 0.330938L15.375 7.41619V-0.375H14.25V9.75H30V8.625H22.1318ZM-6 14.25V15.375H2.03362L-5.79581 20.0454C-5.424 21.6514 -4.54087 22.9699 -3.16331 23.7146L8.625 16.6823V24.375H9.75V14.25H-6ZM30 14.25H14.25V24.375H15.375V16.6232L27.2167 23.6876C28.5786 22.9294 29.4465 21.603 29.8065 19.9943L22.0654 15.375H30V14.25ZM8.625 -0.375V7.35713L-3.19931 0.303375C-4.56619 1.05713 -5.43975 2.38125 -5.80369 3.98944L1.96725 8.625H-6V9.75H9.75V-0.375H8.625Z'
        fill='#E6E7E8'
      />
      <path
        d='M14.25 9.75V-0.375H9.75V9.75H-6V14.25H9.75V24.375H14.25V14.25H30V9.75H14.25Z'
        fill='#BE1E2D'
      />
      <path
        d='M6.33993 8.62577L-4.9382 1.8932C-5.18063 2.2532 -5.37526 2.6492 -5.53613 3.07108L3.77155 8.62577H6.33824M29.4879 21.0514L20.0306 15.3758H17.4116L28.8377 22.249C29.102 21.8783 29.3203 21.4769 29.4879 21.0536M28.1542 0.970703L15.3574 8.62577L17.9556 8.62745L28.998 2.01639C28.7516 1.56808 28.4917 1.27895 28.1542 0.970703ZM-4.98038 22.0555C-4.72733 22.4408 -4.42283 22.7898 -4.07532 23.0927L8.66024 15.3758H6.09355L-4.98038 22.0555Z'
        fill='#BE1E2D'
      />
    </g>
  </svg>
)
